import React from "react";
import C from "classnames";
export const ButtonGroup = (props) => {
    return (React.createElement("div", { className: C("btn-group", props.toggle && "btn-group-toggle", props.block && "btn-block", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=ButtonGroup.js.map